//import "./App.css";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { Fragment } from "react";
import Login from "./Login";
import Register from "./Register";
import Reset from "./Reset";
import Dashboard from "./Dashboard";
import Devices from "./Devices";
import Device from "./Device";
import Clients  from "./Clients";
import ClientDetail  from "./ClientDetail";
import AdminTools from "./AdminTools";

import AppBar from './AppBar';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import { ThemeProvider, createTheme, makeStyles } from '@material-ui/core/styles';

const theme = createTheme();

const useStyles = makeStyles((theme) => {
  root: {
    // some css that access to theme
  }
});

function App() {
  return (
    <ThemeProvider theme={theme}>
    <LocalizationProvider dateAdapter={AdapterDayjs}>
    <Fragment>
      <BrowserRouter>
        <Switch>
          <Route exact path="/" component={Login} />
          <Route exact path="/register" component={Register} />
          <Route exact path="/reset" component={Reset} />
          <Fragment>
            <AppBar />
            <Route exact path="/dashboard" component={Dashboard} />
            <Route exact path="/devices" component={Devices} />
            <Route exact path="/device" component={Device} />
            <Route exact path="/clients" component={Clients} />
            <Route exact path="/client" component={ClientDetail} />
            <Route exact path="/admintools" component={AdminTools} />
          </Fragment>
        </Switch>
      </BrowserRouter>
    </Fragment>
    </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;
